<template>
  <div id="CartPage">
    <NavBar/>
    <v-main class="third-bg">
      <div class="container-fluid third-bg py-15">
        <div class="container-md">
          <div class="row">
            <div class="col-12 text-center">
              <h1>
                <span class="font-19 border-bottom-gold px-5">سبد خرید</span>
              </h1>
            </div>
          </div>
          <div v-if="currentBag.length>0">
            <div class="row">
              <div class="col-12">
                <v-data-table
                    key="CartId"
                    :headers="headers"
                    :items="currentBag"
                    :items-per-page="15"
                    :light="true"
                    :mobile-breakpoint="769"
                    class="data-table"
                    fixed-header>

                  <template v-slot:[`item.Product.MainOriginalFileUrl`]="{ item }">
                    <div class="p-2 d-flex justify-content-center">
                      <v-img v-if="item.Product.MainOriginalFileUrl != null"
                             :src="$replaceHttps(item.Product.MainOriginalFileUrl)" contain
                             height="130" width="130">
                      </v-img>
                      <v-img v-else :src="getImgUrl(src)" contain
                             height="100" width="100"></v-img>
                    </div>
                  </template>

                  <template v-slot:[`item.Amount`]="{ item }">
                    <td class="text-center">
                      {{ $numberWithCommas(item.Amount) }}
                    </td>
                  </template>

                  <template v-slot:[`item.Product.Price`]="{ item }">
                    <td class="text-center">
                      {{ $computingPriceOffer(item.Product.Price, item.Product.DiscountPercent) }}
                    </td>
                  </template>

                  <template v-slot:[`item.TotalRow`]="{ item}">
                    <td v-if="item.Product.DiscountPercent !== 0" class="text-center">

                      {{
                        $computingTotalPrice($computingPriceOffer(item.Product.Price, item.Product.DiscountPercent), item.Quantity)
                      }}
                    </td>
                    <td v-else class="text-center">

                      {{
                        $computingTotalPrice(item.Product.Price, item.Quantity)
                      }}
                    </td>

                  </template>

                  <template v-slot:[`item.removeData`]="{ item}">
                    <td class="text-center">
                      <v-btn class="pt-1" color="primary" icon
                             @click="deleteItem(item.ProductId)">
                       <span><i class="fas fa-trash-alt pl-1 "
                       ></i></span>
                      </v-btn>
                    </td>
                  </template>

                  <template v-slot:[`item.Quantity`]="{ item }">
                    <td class="text-center">
                      <v-btn class="pt-1" color="primary" icon @click="addToCart(item.ProductId)">
                       <span><i class="fas fa-plus pl-1 "
                       ></i></span>
                      </v-btn>
                      <span class="mx-2">{{ item.Quantity }}</span>
                      <v-btn class="pt-1" color="primary" icon
                             @click="MinusOrder(item.ProductId)">
                <span><i class="fas fa-minus pl-1"
                ></i></span>
                      </v-btn>
                    </td>
                  </template>

                  <!--                <template v-slot:[`item.FileUrl`]="{  }">
                                    <td class="p-2">
                                      <v-img :src="$replaceHttps('1.png')" height="150"
                                             width="150">
                                      </v-img>
                                    </td>
                                  </template>-->
                </v-data-table>
              </div>
            </div>
            <div class="footer-border-bottom">
              <div class="row pb-3" dir="ltr">
                <div class="col-md-5 col-12 text-center mx-4">
                <span class="font-18"><span
                    class="second-color font-18">جمع فاکتور:</span> {{
                    $numberWithCommas(totalPriceFactor)
                  }} تومان</span>
                  <v-text-field
                      v-model="discountCode"
                      class=" mt-5 "
                      dense
                      dir="rtl"
                      flat
                      hide-details
                      placeholder="ورود کد تخفیف"
                      solo
                  ></v-text-field>
                  <v-btn
                      block
                      class="mt-2 "
                      color="secondary"
                      elevation="0"
                      @click="setDiscountCode"
                  ><span class="">ثبت کد</span>
                  </v-btn>
                  <div class="mt-4 font-16"><span class="second-color font-18">  قابل پرداخت: </span>
                    <span v-if="discountPercent === 0">{{ $numberWithCommas(totalPriceFactor) }} تومان</span>
                    <div v-else>
                      <div class="text-decoration-line-through">
                        {{ $numberWithCommas(totalPriceFactor) }} تومان
                      </div>
                      <div>{{ $computingPriceOffer(totalPriceFactor, discountPercent) }} تومان
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <!--              <div v-if="hasPhysicalProduct" class="col-md-6 col-12">
                                <div class="text-center">
                                  از روی نقشه محلی که می خواهید محصول سفارش داده شده را تحویل بگیرید انتخاب نمایید
                                </div>
                                <div>
                                  <v-btn class="loc-btn" icon @click="getCurrentLocation">
                                    <v-icon small>fas fa-location</v-icon>
                                  </v-btn>
                                  <GmapMap
                                      ref="mapRef"
                                      :center="myCoordinates"
                                      :options='{ fullscreenControl: false, mapTypeControl: false }'
                                      :zoom="zoom"
                                      style="height:360px"
                                      @click="mark">
                                    <GmapMarker
                                        v-for='(marker,index) in markers'
                                        :key="index"
                                        :animation="2"
                                        :clickable="true"
                                        :position="marker"
                                        @click="center=marker"/>
                                  </GmapMap>
                                </div>
                              </div>-->
                <div class="col-md-6 col-12">
                  <div v-if="hasPhysicalProduct">
                    <div class="mb-1">آدرس را انتخاب کنید.</div>
                    <v-autocomplete
                        v-model="addressListModel"
                        :items="addressListItems"
                        dense
                        flat
                        hide-details
                        item-text="Address"
                        item-value="DeliveryAddressID"
                        solo>
                    </v-autocomplete>
                    <div class="text-center">
                      <v-btn
                          :to="{path:'manageAddress' , query:{isNew :true , fromCart : true}}"
                          class="mt-2 my-3 "
                          color="primary"
                          elevation="0"
                      >
                        ثبت آدرس جدید
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div>
                    <v-textarea
                        v-model="userDescription"
                        auto-grow
                        class="mt-2"
                        flat
                        name="input-7-4"
                        placeholder="اگر توضیح یا مطلب خاصی دارید وارد کنید"
                        solo
                    ></v-textarea>
                  </div>
                  <div class="d-flex justify-content-center">
                    <!--                  <v-btn
                                          class="mt-2 "
                                          color="secondary"
                                          @click="setOrder"
                                      ><span class="black&#45;&#45;text">پرداخت در محل</span>
                                      </v-btn>-->
                    <v-btn
                        class="mt-2 "
                        color="primary"
                        elevation="0"
                        @click="goToBank">
                      پرداخت آنلاین
                    </v-btn>
                    <v-btn
                        class="mt-2 mr-2"
                        color="primary"
                        elevation="0"
                        @click="offlinePay">
                      ثبت سفارش
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <v-alert class="text-center mt-5" color="primary" outlined>محصولی در سبد خرید شما موجود نیست
            </v-alert>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <FooterComponent/>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="530">
      <v-card class="text-center">
        <v-card-title class="justify-space-between secondary-bg">
          <v-btn
              color="primary"
              icon
              @click="showResultDialog = false">
            <i class="fas fa-times ml-1"></i>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <div class="mb-0 black--text py-5">{{ dialogResult }}</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "Cart",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {NavBar, FooterComponent},
  data: () => ({
    headers: [
      {text: 'عکس', value: 'Product.MainOriginalFileUrl', sortable: false,},
      {text: 'محصول', value: 'Product.Name', sortable: false},
      {text: 'قیمت', value: 'Product.Price', sortable: false},
      {text: 'تخفیف', value: 'Product.DiscountPercent', sortable: false},
      {text: '', value: 'Quantity', sortable: false},
      {text: 'قیمت کل', value: 'TotalRow', sortable: false},
      {text: '', value: 'removeData', sortable: false},
    ],
    currentBag: [],
    discountCode: null,
    markers: [],
    center: {lat: 45.508, lng: -73.587},
    myCoordinates: {
      lat: 35.723524,
      lng: 51.396660
    },
    zoom: 10,
    userAddress: null,
    addressListModel: null,
    addressListItems: [],
    userDescription: null,
    discountPercent: 0,
    totalPrice: null,
    totalPriceFactor: null,
    dialogResult: null,
    showLoaderDialog: false,
    showResultDialog: false,
    hasPhysicalProduct: false,
  }),
  created () {
    this.$getLocation({})
        .then(coordinates => {
          this.myCoordinates = coordinates;
          this.markers.push(this.myCoordinates)
        })
        .catch(error => console.log(error));
  },
  mounted () {
    this.getData()
    if (this.$getUserData().token === '') {
      this.$router.replace({path: '/HomePage'})
    }

  },
  methods: {
    MinusOrder (id) {
      this.showLoaderDialog = true
      let resStatus = null
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("productId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ReduceProductFromCart", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.showResultDialog = true
              this.dialogResult = result
              this.showLoaderDialog = false
              setTimeout(function () {
                window.location.reload();
              }, 1000);
              this.getData()
            }
          })
          .catch(error => console.log('error', error));
    },
    addToCart (id) {
      this.showLoaderDialog = true
      let resStatus = null
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("productId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/AddProductToCart", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.showResultDialog = true
              this.dialogResult = result
              this.getData()
              this.showLoaderDialog = false
            }
          })
          .catch(error => console.log('error', error));

    },
    setDiscountCode () {
      let resStatus = null
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("discountCodeString", this.discountCode);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/SetDiscountCode", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            let json = JSON.parse(result)
            if (resStatus === 200) {
              this.dialogResult = json.message
              this.showResultDialog = true
              this.discountPercent = json.discountPercent
              this.showLoaderDialog = false
            } else {
              this.dialogResult = json.message
              this.showResultDialog = true
              this.showLoaderDialog = false
            }
          })
          .catch(error => console.log('error', error));
    },
    getCurrentLocation () {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push(this.myCoordinates)
              this.$refs.mapRef.$mapPromise.then(map => map.panTo(coordinates));

            } else {
              this.markers.push(this.myCoordinates)
            }
          })
          .catch(error => console.log(error));
    },
    mark (event) {
      if (this.markers.length > 0) {
        this.markers.pop()
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      } else {
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      }
    },
    goToBank () {
      this.showResultDialog = true
      this.dialogResult = "این بخش پس از اتصال به درگاه فعال میشود."
    },
    getData () {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/CartContents", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.showLoaderDialog = false
            this.currentBag = json
            let discountPrice = 0;
            for (let i = 0; i < json.length; i++) {
              discountPrice += parseInt(this.$computingTotalPrice(this.$computingPriceOffer(json[i].Product.Price, json[i].Product.DiscountPercent), json[i].Quantity).replace(/,/g, ''));

              if (json[i].Product.TypeProduct === 1) {
                this.hasPhysicalProduct = true
              }
            }
            this.totalPriceFactor = discountPrice
            /*       setTimeout(function () {
                     window.location.reload();
                   }, 1000);*/
            this.getAddresses()
          })
          .catch(error => console.log('error', error));
    },
    deleteItem (id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("productId", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/RemoveProductFromCart", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.dialogResult = result
            this.showResultDialog = true
            setTimeout(function () {
              window.location.reload();
            }, 1000);
            this.getData()
          })
          .catch(error => console.log('error', error));
    },
    getAddresses () {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/DefineDeliveryList", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.addressListItems = json
            this.loading = false
            for (let i = 0; i < json.length; i++) {
              json[i].fullName = json[i].Name + " " + json[i].Family;
            }

          })
          .catch(error => console.log('error', error));
    },
    offlinePay () {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      if (this.discountCode !== null) {

        formdata.append("discountCodeString", this.discountCode);
      }
      formdata.append("deliveryAddressId", this.addressListModel);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      let resStatus = null


      fetch(this.$baseUrl + "/Client/SetOfflineInvoice", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            this.showLoaderDialog = false
            if (resStatus === 200) {
              this.$router.push({path: 'OrdersRecords'})
            } else {
              this.dialogResult = result
              this.showResultDialog = true
            }

          })
          .catch(error => console.log('error', error));
    }

  }
}
</script>

<style scoped>

</style>
